<template>
    <div class="form-container active" id="step-2">
        <div class="row">
            <div class="col-lg-3">
                <appointment-summary :config="config" :prestations="get_prestations"
                :selected_free_time="selected_free_time"
                :can_select_number="can_select_number" :start_date="getStartDate" :location="location" :rdvs="rdvs_data"
                :can_unselect="true" @back="this.$emit('back')" @unselected="set_unselect_multiple($event)">
                </appointment-summary>
            </div>
            <div class="col-lg-6">
                <div class="agenda-bloc">
                    <h4 class="date-title">Sélectionner une date</h4>
                    <DatePicker v-if="first_date" :config="config" :first_date="first_date" :free_days="updated_days" :can_select_number="current_left_number_to_select" @selected="set_start_date($event)" @monthChanged="update_freedays_by_month($event)"></DatePicker>
                    <div v-else class="creneau-vide">
                        <svg width="42" height="45" viewBox="0 0 42 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M27.5995 25.7245L24.4531 28.875L27.6056 32.0255C28.0635 32.4834 28.3208 33.1044 28.3208 33.752C28.3208 34.3996 28.0635 35.0207 27.6056 35.4786C27.1477 35.9365 26.5266 36.1938 25.8791 36.1938C25.2315 36.1938 24.6104 35.9365 24.1525 35.4786L21 32.3281L17.8495 35.4806C17.3916 35.9385 16.7706 36.1958 16.123 36.1958C15.4754 36.1958 14.8543 35.9385 14.3964 35.4806C13.9385 35.0227 13.6812 34.4016 13.6812 33.7541C13.6812 33.1065 13.9385 32.4854 14.3964 32.0275L17.5469 28.875L14.4005 25.7245C14.1737 25.4978 13.9939 25.2286 13.8712 24.9324C13.7485 24.6361 13.6853 24.3186 13.6853 23.998C13.6853 23.6773 13.7485 23.3598 13.8712 23.0636C13.9939 22.7673 14.1737 22.4981 14.4005 22.2714C14.6272 22.0447 14.8964 21.8648 15.1926 21.7421C15.4889 21.6194 15.8064 21.5562 16.127 21.5562C16.4477 21.5562 16.7652 21.6194 17.0614 21.7421C17.3577 21.8648 17.6269 22.0447 17.8536 22.2714L21 25.4219L24.1505 22.2694C24.3772 22.0426 24.6464 21.8628 24.9426 21.7401C25.2389 21.6174 25.5564 21.5542 25.877 21.5542C26.1977 21.5542 26.5152 21.6174 26.8114 21.7401C27.1077 21.8628 27.3769 22.0426 27.6036 22.2694C27.8303 22.4961 28.0102 22.7653 28.1329 23.0615C28.2556 23.3578 28.3188 23.6753 28.3188 23.9959C28.3188 24.3166 28.2556 24.6341 28.1329 24.9303C28.0102 25.2266 27.8303 25.4958 27.6036 25.7225L27.5995 25.7245ZM41.3125 7.75V40.25C41.3125 41.3274 40.8845 42.3608 40.1226 43.1226C39.3608 43.8845 38.3274 44.3125 37.25 44.3125H4.75C3.67256 44.3125 2.63925 43.8845 1.87738 43.1226C1.11551 42.3608 0.6875 41.3274 0.6875 40.25V7.75C0.6875 6.67256 1.11551 5.63925 1.87738 4.87738C2.63925 4.11551 3.67256 3.6875 4.75 3.6875H8.8125V2.875C8.8125 2.22853 9.06931 1.60855 9.52643 1.15143C9.98355 0.694307 10.6035 0.4375 11.25 0.4375C11.8965 0.4375 12.5165 0.694307 12.9736 1.15143C13.4307 1.60855 13.6875 2.22853 13.6875 2.875V3.6875H28.3125V2.875C28.3125 2.22853 28.5693 1.60855 29.0264 1.15143C29.4835 0.694307 30.1035 0.4375 30.75 0.4375C31.3965 0.4375 32.0165 0.694307 32.4736 1.15143C32.9307 1.60855 33.1875 2.22853 33.1875 2.875V3.6875H37.25C38.3274 3.6875 39.3608 4.11551 40.1226 4.87738C40.8845 5.63925 41.3125 6.67256 41.3125 7.75ZM5.5625 8.5625V13.4375H36.4375V8.5625H33.1875C33.1875 9.20897 32.9307 9.82895 32.4736 10.2861C32.0165 10.7432 31.3965 11 30.75 11C30.1035 11 29.4835 10.7432 29.0264 10.2861C28.5693 9.82895 28.3125 9.20897 28.3125 8.5625H13.6875C13.6875 9.20897 13.4307 9.82895 12.9736 10.2861C12.5165 10.7432 11.8965 11 11.25 11C10.6035 11 9.98355 10.7432 9.52643 10.2861C9.06931 9.82895 8.8125 9.20897 8.8125 8.5625H5.5625ZM36.4375 39.4375V18.3125H5.5625V39.4375H36.4375Z" fill="#FBBC00"/>
                        </svg>
                        <h5>Aucune date disponible.</h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-3">
                <TimePicker :key="'timepicker'" :days="days" :selected_day="this.start_date" :free_times="free_times" :configs="config" :can_select_number="can_select_number" :current_left_number_to_select="current_left_number_to_select" :unselect="unselect_multiple_computed" @selected="set_free_time($event)" @unselected="unset_free_time($event)"></TimePicker>
            </div>
        </div>
        <div class="btn-container">
            <a v-if="config['ENABLE_HEADER_FOOTER'] == 0" class="iframe-logo" href="#">
              <img src="/assets/images/logo-footer.svg" alt="logo">
            </a>
            <div class="buttons-right">
                <button class="btn-secondary1" id="prevBtn" @click="$emit('back')" :disabled="!can_modify()">Modifier les prestations</button>
                <button class=" btn-primary1" id="nextBtn" @click="submit()" :disabled="!can_submit" > 
                    {{ 
                        can_submit ? 'Suivant' 
                        : can_select_number > Object.keys(rdvs_data).length ? `Sélectionnez ${current_left_number_to_select} créneau(x)`
                            : `Retirez ${current_exceed_selected_number} créneau(x)`
                    }}
                </button>
            </div>
        </div>
    </div>    
</template>

<script>
import { Inertia } from "@inertiajs/inertia";
import axios from 'axios';
import moment from 'moment';
import AppointmentSummary from "./AppointmentSummary.vue";
import TimePicker from "./TimePicker.vue";
import DatePicker from "./DatePicker.vue";
import { BookingStore } from "../Stores/BookingStore";
import { toast } from "bulma-toast";
import { BookingUtility } from "../Utilities/booking_utility";

export default {
    name: 'SelectTimeSlot',
    emits: ['back','submit','located'],
    props: ['agendas','agenda', 'config', 'locations','location','prestations', 'group_sizes', 'fo_config', 'price', 'rdv'],
    components: { AppointmentSummary, TimePicker, DatePicker },

    data () {
        return {
            agenda_id: null,
            // agenda: null,
            rdv_data: null,
            rdvs_data: {},
            client_infos: null,
            days: {},
            first_date: null,
            // free_times: [],
            group_size: null,
            is_loading: false,
            // location: null,
            show_popup: false,
            time_slot_clicked: false,
            start_date: null,
            start_date_time: null,
            store: BookingStore,
            selected_time_slot: {},
            selected_free_time: null,
            unselect_multiple: null
        }
    },
    computed: {
        getStartDate() {
            return this.start_date
        },
        allow_subgroup () {
            this.prestations[0]?.allow_subgroup
        },
        availableAgendas () {
            if (!this.location_id) return this.agendas
            return this.agendas.filter(agenda => agenda.location_id == this.location_id)
        },
        can_scroll_right () {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft === 0
        },
        getPrice () {
            if (
                !this.config.display_price
                ||
                this.prestations.find(prestation => !prestation.display_price)
            ) return 'Non communiqué'
            return this.price;
        },
        getDuration () {
            if (
                !this.config.display_duration
                ||
                this.prestations.find(prestation => !prestation.display_duration)
            ) return 'Durée non communiquée'

            let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' minutes'
            return str
        },
        is_prestation_groupe() {
            return this.prestations[0]?.is_group
        },
        max_group_size () {
            return this.prestations[0]?.max_nbr_clients
        },
        no_free_times () {
            return Object.values(this.days).every(day => day.free_times.length === 0)
        },
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
        theme(){
            return this.fo_config['theme'];
        },
        redirected(){
            return this.fo_config && this.fo_config['redirected'] && (this.fo_config['redirected'] == 1);
        },
        get_prestations(){
            return this.prestations;
        },
        free_times() {
            return this.days[this.start_date]?.free_times ?? [];
        },
        updated_days(){
            return this.days;
        },
        can_select_number(){
            // Si c'est la modification le nombre est automatiquement à 1
            if(BookingStore.rdvToModify) return 1;
            if(this.config['MULTIPLE_RDV'] == 0) return 1;

            let number = 1;
            if(this.config['MULTIPLE_RDV_BASED_FIELD']){
                const field = this.config.fields?.find(f => f.efs_id == this.config['MULTIPLE_RDV_BASED_FIELD']);
                if(BookingStore.user_infos){
                    number = BookingStore.user_infos[field.internal_col_name];
                }
            }
            return number >= 1 ? number : 1;
        },
        can_submit(){
            if(this.time_slot_clicked){
                // Si modification il peut soumettre si click.
                if(BookingStore.rdvToModify) return true;

                if(this.config['MULTIPLE_RDV'] == 1){
                    if((this.config['MULTIPLE_RDV_SLOT_IMPOSITION'] == 1  && this.can_select_number == Object.keys(this.rdvs_data).length)
                        || (this.config['MULTIPLE_RDV_SLOT_IMPOSITION'] == 0 && Object.keys(this.rdvs_data).length >= 1)){
                        console.log('can_submit 1');
                        return true;
                    }else{
                        console.log('can_submit 2');
                        return false;
                    }
                }else{
                    console.log('can_submit 3');
                    return true;
                }
            }
            console.log('can_submit 4');
            return false;
        },
        unselect_multiple_computed(){
            return this.unselect_multiple;
        },
        current_left_number_to_select(){
            return this.can_select_number - Object.keys(this.rdvs_data).length;
        },
        current_exceed_selected_number(){
            return Object.keys(this.rdvs_data).length - this.can_select_number;
        }
    },

    methods: {
        can_modify(){
            return !BookingStore.rdvToModify;
        },
        getAttendeesFromRdv(rdv){
            if(rdv && rdv.participants){
                for (const participant of rdv.participants) {
                    if (participant.client_id == this.user.client_id) {
                        let attendees = JSON.parse(participant.attendees ?? '[]');
                        return attendees;
                    }
                }
            }
            return null;
        },
        withAuth(){
            return !(this.config && this.config["BOOK_WITHOUT_SUBSCRIPTION"] && this.config["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
        },
        withAutoSelectNext(){
            return (this.config && this.config["AUTO_BOOKING"] && this.config["AUTO_BOOKING"] == 1);
        },
        formatDate (d) {
            let date = new Date(d)
            let days = ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.']
            let months = ['jan.', 'fév.', 'mars.', 'avr.', 'mai.','juin.', 'juil.', 'aout.', 'sept.', 'oct.', 'nov.', 'déc.']
            return days[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + months[date.getUTCMonth()]
        },
        formatDateMoment(date, format) {
            return moment(date).locale('fr').format(format)
        },
        getEmptySlotsNumber (day) {
            let slot_number = []
            for (let day in this.days) {
                slot_number.push(this.days[day]?.free_times?.length || 0)
            }
            const max_number = Math.max(...slot_number)
            return max_number - day.free_times.length
        },
        getSelectedPrestationsString () {
            return this.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
        },
        getSelectedPrestationsIds(){
            return this.prestations.map(prestation => prestation.prestation_id);
        },
        getImage() {
            let prestation_with_image = this.prestations.find(prestation => prestation.image)
            if (!prestation_with_image) return false
            return prestation_with_image.image
        },
        getFreeTimes (start_date = null, min_date = null, max_date = null, nbr_days = null) {
            // console.log('selectTimeSlot getFreeTimes', BookingStore.rdvToModify, this.user?.client_id);
            
            let prestation_id = this.prestations.map(prestation => prestation.prestation_id).join('/')
            let query = {}
            if (this.location && parseInt(this.location.location_id)) query.location = this.location.location_id
            if (this.agenda && parseInt(this.agenda.agenda_id)) query.agenda = this.agenda.agenda_id
            if (this.prestations.find(prestation => prestation.is_group)) {
                query.group_size = !BookingStore.rdvToModify ? BookingStore.get_groupe_size() : (1 + (BookingUtility.get_attendees_from_rdv(BookingStore.rdvToModify, this.user?.client_id)?.length ?? 0));
            }
            if (start_date) query.from = start_date
            let params = new URLSearchParams(query)

            this.is_loading = true
            let url = `/rdv/slots/with-prestations/${prestation_id}?${params}`
            // Bornage si existe dans le cas de la redirection
            let redirected_params = this.get_redirected_params();
            
            if(redirected_params){
                url = url+`&redirected=1`;
            }

            if(redirected_params && redirected_params.min_date && redirected_params.max_date){
                url = url+`&min_date=${redirected_params.min_date}&max_date=${redirected_params.max_date}`;
            }else if(min_date && max_date){
                url = url+`&min_date=${min_date}&max_date=${max_date}`;
            }
            if(nbr_days){
                url += `&days=${nbr_days}`;
            }
            return axios.get(url).then(response => {
                let data = response.data
                this.setDays(data)
                this.is_loading = false
            })
        },
        get_redirected_params(){
            if(!this.redirected){
                return null;
            }

            let all_params = new URLSearchParams(window.location.search);
            let params = all_params.get('all_params_redirect');
            if(params != null){
                return JSON.parse(atob(params));
            }
            return null;
        },
        hideModal () {
            this.show_popup = false
            this.start_date = null
            let active_button = document.querySelector('.free_time_button.is-active')
            if (active_button) active_button.classList.remove(('is-active'))
            this.time_slot_clicked = false;
        },
        parseUrl() {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('agenda_id') && parseInt(urlParams.get('agenda_id'))) {
                this.agenda_id = urlParams.get('agenda_id')
                let agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id);
                this.store.setAgenda(agenda);
                if (!this.store.selected_agenda) return this.$inertia.get('/ressources')
            }
            if (!this.location) return this.$inertia.get('/ressources');
            // if (urlParams.get('location_id') && parseInt(urlParams.get('location_id'))) {
            //     // this.location_id = urlParams.get('location_id')
            //     // this.location = this.locations.find(location => location.location_id == this.location_id)
            //     if (!this.location) return this.$inertia.get('/ressources')
            // }
            if (this.prestations.find(prestation => prestation.is_group)) {
                if (this.prestations.length > 1) {
                    toast({
                        message: 'Impossible de combiner les prestations de groupe avec d\'autre prestations.',
                        type: 'is-danger',
                        duration: 4000,
                        pauseOnHover: true
                    })
                    return this.$inertia.get('ressources')
                }
                let prestation = this.prestations[0]
                if (!prestation.allow_subgroup) this.group_size = 1
                else {
                    console.log('SelectTimeSlot parseUrl rdvToModify', this.store.rdvToModify);
                    this.group_size = parseInt(urlParams.get('group_size')) || 1}
            }
        },
        isEndOfContainer () {
            let container = document.querySelector('#free-times-container')
            return container.scrollLeft >= container.scrollWidth - container.clientWidth - 1
        },
        isFirstDate() {
            let first_date = Object.keys(this.days)[0]
            return !moment().isAfter(first_date, 'day')
        },
        renderLocationAddress(location) {
            if (!location.address) return ''
            let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
            return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
        },
        scrollLeft() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft += scroll_level
            // if (container.scrollLeft > 0) this.can_scroll_right = true
        },
        scrollRight() {
            let container = document.querySelector('#free-times-container')
            let scroll_level = container.offsetWidth
            container.scrollLeft -= scroll_level

            // if (container.scrollLeft === 0) this.can_scroll_right = false

        },
        setDays(data) {
            data.sort((a,b) => (new Date(a.start)).getTime() - (new Date(b.start)).getTime());
            let slotsPerDays = new Map();
            for(let slot of data){
                let d = slot.start.split(' ')[0];
                if(slotsPerDays.has(d)){
                    slotsPerDays.get(d).push(slot)
                }else{
                    slotsPerDays.set(d, [slot]);
                }
            }
            for(let [day,slots] of slotsPerDays.entries()){
                this.days[day] = {
                    date: day,
                    date_string: this.formatDate(day),
                    free_times: slots,
                };
            }
                
            // }
            // this.first_date_auto = Object.entries(this.days)[0][1]
            // this.first_date = Object.keys(this.days)[0]
            const entries = Object.entries(this.days);

            if (entries.length > 0) {
                this.first_date_auto = entries[0][1];
                this.first_date = entries[0][0];
            } else {
                this.first_date_auto = null;
                this.first_date = null;
            }
            // console.log('selecttimeslot days',this.days)
        },
        set_start_date(start_date){
            this.start_date = start_date;

            if(this.can_select_number <= 1) {
                this.selected_free_time = null;
                this.time_slot_clicked = false;
                this.rdv_data = null;
                this.rdvs_data = {};
            }

            this.$nextTick(() => {
                const timePicker = document.querySelector('.creneau');
                if (timePicker) {
                    timePicker.scrollIntoView({ 
                        behavior: 'smooth', 
                        block: 'start' 
                    });
                }
            }); 
        },

        set_free_time (free_time) {
            if (free_time === null) {
                this.time_slot_clicked = false;
                this.selected_free_time = null;
                return
            }
            if(moment(free_time.start).isValid()){
                this.time_slot_clicked = true;
                this.selected_free_time = free_time;
                
                if (this.store.rdvToModify) {
                    this.rdv_data = this.store.rdvToModify
                }
                if(!this.rdv_data){
                    this.rdv_data = {}
                }else{
                    this.rdv_data.current_client = this.user;
                }
                if (free_time.title) {
                    this.rdv_data.free_time_title = free_time.title;
                }
                this.rdv_data.day  = moment(free_time.start).format('YYYY-MM-DD');
                this.rdv_data.heure  = moment(free_time.start).format('HH:mm');
                this.rdv_data.start_date = this.start_date;
                let duration = this.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
                this.rdv_data.end_date = moment(free_time.start).add(duration, 'minutes').format('YYYY-MM-DD HH:mm');
                this.rdv_data.idAgenda  = free_time.agenda_id;
                this.rdv_data.idPrestation  = this.prestations.map(prestation => prestation.prestation_id).toString();
                this.rdv_data.location_id  = this.location?.location_id;

                if (this.store.rdvToModify) {
                    this.rdv_data.start_date = free_time.start

                    const date = new Date(this.rdv_data.updated_at);                    
                    const newDate = new Date(date.toLocaleString('en-US', { timeZone: this.config['timezonecity'] }));
                    this.rdv_data.updated_at = moment(newDate).format("YYYY-MM-DD HH:mm:ss")
                    // Mise à jour du rdv dans le store
                    this.store.rdvToModify = this.rdv_data;
                }else{ // il ne s'agit pas de la modification
                    // Taille du groupe
                    this.rdv_data.group_size  = this.group_size;
                    // Cas de rdvs multiples
                    if(this.config['MULTIPLE_RDV'] == 1){
                        this.rdv_data.free_time = free_time;
                        // this.rdv_data['by_client'] = this.user;
                        this.rdv_data['for_client'] = this.user;
                        // console.log('Avant ajout à rdvs_data:', this.rdv_data, free_time);
                        this.rdvs_data[free_time.start+''] = JSON.parse(JSON.stringify(this.rdv_data));
                    }
                }
                console.log('set_free_time',free_time,this.rdvs_data,this.rdv_data);
            }else{
                toast({
                    message: "Date invalide: Il y a un problème avec le créneau choisi",
                    type: 'is-danger',
                    duration: 5000,
                    pauseOnHover: true
                })
            }
        },
        unset_free_time(free_time){
            console.log('selectTimeSlot unset_free_time',free_time);
            delete this.rdvs_data[free_time.start+''];
            if (this.selected_free_time && this.selected_free_time.start === free_time.start) {
                this.selected_free_time = null;
            }
        },
        switchNext () {
            let container = document.querySelector('#free-times-container')
            if (container.scrollLeft + container.offsetWidth >  container.scrollWidth - container.clientWidth){
                this.loadNext().then(()=>this.$nextTick()).then(()=>this.scrollLeft())
            }else{
                this.scrollLeft()
            }

        },
        loadNext(){
            let last_date = Object.keys(this.days).pop()
            let start_date = moment(last_date).add(1, 'days').format('YYYY-MM-DD')
            return this.getFreeTimes(start_date)
        },
        update_freedays_by_month(month){
            // let last_date = Object.keys(this.days).pop()
            let min_date = moment(month+"-01").format('YYYY-MM-DD')
            return this.getFreeTimes(min_date,null,null,31);
        },
        onFreesTimeScroll(){
            if(this.isEndOfContainer()){
                this.loadNext();
            }
        },
        toggleAuthModal () {
            let modal = document.querySelector('#auth-modal')
            modal.classList.toggle('is-active')
        },
        submitClientInfos(data){
            // console.log("submitClientInfos");
            
            this.client_infos = data;
            this.show_popup = true;
        },
        submit(){
            this.$emit('submit', this.config['MULTIPLE_RDV'] == 1 ? this.rdvs_data : this.rdv_data);
        },
        set_unselect_multiple(rdv){
            console.log('SelectTimeSlot set_unselect_multiple',rdv);
            this.unselect_multiple = rdv;
        }
    },
    mounted () {
        this.store = BookingStore;
        console.log('SelectTimeSlot rdv to modify', this.store.rdvToModify);

        window.scrollTo({ top: 0, behavior: 'smooth' }); // scroll

        // this.parseUrl();
        
        // Initialisation du token et authentification de l'utilisateur
        if('redirected' in this.fo_config && this.fo_config['redirected'] == 1){
            let token = (new URLSearchParams(location.search)).get('token');
            if(token){
                axios.post('/redirect/auth/login', {
                    token: token
                })
                .then(response => {
                    this.form_error = null;
                    let user = response.data.client;
                    this.$emit('userLogin', user);
                    Inertia.reload({ only: ["auth.user"] });
                })
                .catch(err => {
                    this.form_error = err?.response?.data?.message ?? 'Une erreur est survenue'
                })   
            }
        }
       
        // if(!this.location){
        //     if (this.location_id) {
        //         this.location = this.locations.find(location => location.location_id == this.location_id)
        //         if (!this.location) return this.$inertia.get('/ressources')
        //     } else if (this.agenda_id) {
        //         this.agenda = this.agendas.find(agenda => agenda.agenda_id == this.agenda_id)
        //         this.location = this.locations.find(location => location.location_id == this.agenda.location_id)
        //         if (!this.agenda || !this.location) return this.$inertia.get('/ressources')
        //     }
        // }
        // this.$emit('located',this.location);
        // console.log('location',this.location);
        

        this.getFreeTimes().then(()=>{
            // Si La réservation automatique est activée, sélectionner le premier créneau
            if(this.config["AUTO_BOOKING"] === 1){
                let keys = Object.keys(this.days);
                if(keys.length > 0){
                    this.$refs.free_time_00.click();
                }
            }
        });
        
        // En cas de modification initialiser le rdv
        this.rdv_data = this.rdv;
        // if(this.rdv_data.rdv_id){
        //     this.rdv_data.participants = this.getAttendeesFromRdv(this.rdv_data);
        // }
        // console.log("confirmationrdv rdv",this.rdv,this.rdv_data);
        
    },
    updated () {
        if(this.config["AUTO_BOOKING"] == 1 ?? null){
            this.set_start_date(this.first_date_auto['date'])
            this.set_free_time(this.first_date_auto['free_times'][0])
            this.submit()
        }

        // console.log('start_date', this.start_date);
        
        
        // console.log('first_date_auto --->', this.first_date_auto['free_times'][0])
    },
    watch: {
        user(value) {
            if (value && this.rdv_data && this.time_slot_clicked) this.show_popup = true;
        },
        // start_date(value) {
        //     console.log("Start date updated:", value);
        // }
    }    
}

</script>

<style scoped>
    button:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        }
</style>
